export const BASE_AGE_LAYOUT_VERSION = 1;

/** Переименовать колонку, сохранив её место, размеры и явное скрытие. */
export function migrateBaseAgeView<T extends Record<string, unknown>>(view: T): T {
  if (view.baseAgeLayoutVersion === BASE_AGE_LAYOUT_VERSION) return view;
  const result: Record<string, unknown> = { ...view, baseAgeLayoutVersion: BASE_AGE_LAYOUT_VERSION };
  const rename = (key: unknown) => key === 'birthYear' ? 'age' : key;
  if (Array.isArray(view.columns)) {
    const columns = [...new Set(view.columns.map(rename))];
    if (columns.length && !columns.includes('age') && view.baseBirthYearLayoutVersion !== 1) {
      const index = columns.indexOf('birthDate');
      columns.splice(index < 0 ? columns.length : index + 1, 0, 'age');
    }
    result.columns = columns;
  }
  for (const key of ['widths', 'pinned']) {
    const value = view[key];
    if (Array.isArray(value)) result[key] = [...new Set(value.map(rename))];
    else if (value && typeof value === 'object' && Object.hasOwn(value, 'birthYear')) {
      const map = { ...value } as Record<string, unknown>;
      if (!Object.hasOwn(map, 'age')) map.age = map.birthYear;
      delete map.birthYear;
      result[key] = map;
    }
  }
  // Условия по году и направление его сортировки не означают то же для возраста.
  for (const key of ['filters', 'sort']) {
    if (Array.isArray(view[key])) {
      result[key] = view[key].filter(item => !item || typeof item !== 'object' || item.field !== 'birthYear');
    }
  }
  return result as T;
}
